/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Model_Not_EnabledInputs */



/**
* | output |
* | --- |
* | "This model is not enabled for your organization. Ask an administrator to enable it, or pick another model." |
*
* @param {Chat_Error_Model_Not_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_model_not_enabled = /** @type {((inputs?: Chat_Error_Model_Not_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Model_Not_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Modell ist für deine Organisation nicht freigeschaltet. Bitte einen Administrator um Freischaltung oder wähle ein anderes Modell.")
	return /** @type {LocalizedString} */ ("This model is not enabled for your organization. Ask an administrator to enable it, or pick another model.")
});